import { useState } from "react";

import { useForgotPassword } from "@/hooks/use-auth-client";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useLoadingScreen } from "../../side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";
import { AuthForm } from "../_components/auth-form";
import { authForgotPasswordInputZodSchema, type AuthForgotPasswordInputType } from "./_schema/validation-schema";

import type { SafeParseError } from "zod";

export const AuthFormForgotPassword = () => {
	const [email, setEmail] = useState("");

	const [validationErrors, setValidationErrors] = useState<SafeParseError<AuthForgotPasswordInputType> | undefined>(
		undefined,
	);

	const canSubmit = email && !validationErrors;

	const onChangeEmail = (email: string) => {
		setEmail(email);
	};

	const onChangeValidationErrors = (email: string) => {
		const zodErrors = authForgotPasswordInputZodSchema.safeParse({ email });

		zodErrors.success ? setValidationErrors(undefined) : setValidationErrors(zodErrors);
	};

	const handleChangeEmail = (email: string) => {
		onChangeEmail(email);

		onChangeValidationErrors(email);
	};

	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { forgotPassword } = useForgotPassword();
	const handleSubmit = (_e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		showLoadingScreenCallback();

		forgotPassword({ email }).finally(() => {
			onChangeEmail("");
			hideLoadingScreenCallback();
		});
	};

	return (
		<AuthForm
			formTitle="パスワードの再設定"
			primaryButtonText="メールを送信"
			handlePrimaryButtonClick={handleSubmit}
			disabled={!canSubmit}
			otherInfo={
				<div className="flex justify-end">
					<a href={PATHS.AUTH.SIGN_IN}>
						<Button variant="link">サインインはこちら</Button>
					</a>
				</div>
			}
		>
			<InputTextField
				label="登録済みのメールアドレス"
				errorMessage={validationErrors?.error.formErrors.fieldErrors.email?.at(0)}
				type="email"
				placeholder="sample@chillnn.com"
				autoComplete="email"
				name="email"
				value={email}
				handleChange={handleChangeEmail}
			/>
		</AuthForm>
	);
};
